import Icon from "@vfuk/core-icon/";
import Paragraph from "@vfuk/core-paragraph";
import Spacing from "@vfuk/core-spacing";
import styled from "styled-components";

interface ValidationCheckIconProps {
  text: string;
  isValid: boolean;
}

const Wrapper = styled.div<{ isValid: boolean }>`
  display: flex;
  align-items: center;
  opacity: ${({ isValid }) => (isValid ? "1" : ".5")};
`;

const IconWrapper = styled.div`
  margin: -3px 5px 0 0;
`;

const ValidationCheckIcon = ({ text, isValid }: ValidationCheckIconProps) => (
  <Wrapper isValid={isValid}>
    <IconWrapper>
      <Icon
        name="tick-circle"
        group="system"
        state={isValid ? "success" : "error"}
        size={2}
      />
    </IconWrapper>
    <Spacing spacingLevel={{ left: 2 }}>
      <Paragraph noMargin>{text}</Paragraph>
    </Spacing>
  </Wrapper>
);

export default ValidationCheckIcon;
